<nav class="top-nav">
  <ul class="nav-links">
    <li>
      <a routerLink="/employees" routerLinkActive="active">
        <img src="../../../assets/person.svg" alt="" />
        Employees</a
      >
    </li>
    <li>
      <a routerLink="/succession-plan" routerLinkActive="active">
        <img src="../../../assets/portfolio.svg" alt="" />

        Succession Plan</a
      >
    </li>
  </ul>
</nav>
